const chunkMapping = {
	"12": [
		3012
	],
	"48": [
		1048
	],
	"56": [
		3056
	],
	"68": [
		3068
	],
	"131": [
		7131
	],
	"246": [
		4246
	],
	"305": [
		305
	],
	"343": [
		7343
	],
	"355": [
		9355
	],
	"379": [
		6379
	],
	"436": [
		9436
	],
	"444": [
		1444
	],
	"502": [
		5502
	],
	"508": [
		6508
	],
	"527": [
		8527
	],
	"606": [
		1606
	],
	"638": [
		3638
	],
	"683": [
		1683
	],
	"688": [
		4688
	],
	"718": [
		6718
	],
	"724": [
		6724
	],
	"775": [
		6775
	],
	"794": [
		3794
	],
	"824": [
		824
	],
	"847": [
		5847
	],
	"892": [
		8892
	],
	"898": [
		7898
	],
	"994": [
		1994
	]
};
const idToExternalAndNameMapping = {
	"305": [
		"default",
		"./awsSystemCard",
		2639
	],
	"824": [
		"default",
		"./alaceOpportunities",
		8087
	],
	"1048": [
		"default",
		"./alaceCustomers/count",
		8087
	],
	"1444": [
		"default",
		"./alaceMarketingActivities",
		8087
	],
	"1606": [
		"default",
		"./alaceProjectDetails/count",
		8087
	],
	"1683": [
		"default",
		"./alaceProjectSalesActivities",
		8087
	],
	"1994": [
		"default",
		"./auditLogDashboard",
		8087
	],
	"3012": [
		"default",
		"./opportunitiesTable",
		2639
	],
	"3056": [
		"default",
		"./alaceMarketingActivities/count",
		8087
	],
	"3068": [
		"default",
		"./alaceSolutionsOffered",
		8087
	],
	"3638": [
		"default",
		"./conflictsSummary",
		2639
	],
	"3794": [
		"default",
		"./alaceOpportunityTeams/count",
		8087
	],
	"4246": [
		"default",
		"./hubspotWebhookLogs",
		8087
	],
	"4688": [
		"default",
		"./AI-Chat",
		3237
	],
	"5502": [
		"default",
		"./alaceOpportunityTeams",
		8087
	],
	"5847": [
		"default",
		"./alaceMarketingUseCases",
		8087
	],
	"6379": [
		"default",
		"./alaceMarketingChannels",
		8087
	],
	"6508": [
		"default",
		"./alaceOpportunities/count",
		8087
	],
	"6718": [
		"default",
		"./alaceContacts",
		8087
	],
	"6724": [
		"default",
		"./acelinkCard",
		2639
	],
	"6775": [
		"default",
		"./alaceGrappleAuditLog",
		8087
	],
	"7131": [
		"default",
		"./syncHeader",
		2639
	],
	"7343": [
		"default",
		"./navigationTabs",
		2639
	],
	"7898": [
		"default",
		"./alaceProjectDetails",
		8087
	],
	"8527": [
		"default",
		"./alaceAddresses",
		8087
	],
	"8892": [
		"default",
		"./kpiBar",
		2639
	],
	"9355": [
		"default",
		"./alaceDeliveryModels",
		8087
	],
	"9436": [
		"default",
		"./alaceCustomers",
		8087
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}